import React from 'react';
import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
} from '@mui/material';
import { useCustomTheme } from '../../contexts/ThemeContext';
import UserNavbar from './UserNavbar';

const UserPageLayout = ({ title, subtitle, children, heroContent }) => {
  const theme = useTheme();
  const { isDarkMode } = useCustomTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box>
      {/* Navigation */}
      <UserNavbar  />

      {/* Hero Section */}
      <Box
        sx={{
          marginTop:'0px !important',
          position: 'relative',
          height: { xs: '15vh', sm: '15vh', md: '12vh' },
          mt: { xs: 6, sm: 7, md: 8 },
          background: isDarkMode 
            ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)'
            : 'linear-gradient(135deg, #2d1b14 0%, #1a0f0a 100%)',
          color: 'white',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
            zIndex: 1,
          },
        }}
      >
        <Container 
          maxWidth="lg" 
          sx={{ 
            position: 'relative', 
            zIndex: 2, 
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 3, sm: 4, md: 5 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            width: '100%'
          }}
        >
          {title && (
            <Typography 
              variant={isMobile ? "h4" : "h2"} 
              component="h1"
              sx={{
                fontWeight: { xs: 700, sm: 800 },
                textAlign: 'center',
                mb: { xs: 1, sm: 1.5, md: 2 },
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                fontSize: { xs: '1.5rem', sm: '2rem', md: '2rem' },
                lineHeight: { xs: 1.2, sm: 1.3 },
              }}
            >
              {title}
            </Typography>
          )}
          
          {/* {subtitle && (
            <Typography
              variant={isMobile ? "body2" : "h6"}
              sx={{ 
                textAlign: 'center',
                opacity: 0.9,
                maxWidth: { xs: '100%', sm: '600px', md: '800px' },
                mx: 'auto',
                mb: { xs: 2, sm: 3, md: 4 },
                fontSize: { xs: '0.85rem', sm: '1rem', md: '1.125rem' },
                lineHeight: { xs: 1.4, sm: 1.5 },
                px: { xs: 1, sm: 0 },
              }}
            >
              {subtitle}
            </Typography>
          )} */}

          {/* {heroContent && (
            <Box sx={{ 
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {heroContent}
            </Box>
          )} */}
        </Container>
      </Box>

      {/* Content Section */}
      <Box>
        <Container 
          maxWidth="lg" 
          sx={{ 
            py: { xs: 2, sm: 3, md: 6 },
            px: { xs: 1, sm: 2, md: 3 },
            position: 'relative',
            zIndex: 1,
            mt: { xs: -2, sm: -3, md: -4 },
          }}
        >
        <Paper
          elevation={isDarkMode ? 1 : 3}
          sx={{
            borderRadius: { xs: 2, sm: 3, md: 4 },
            p: { xs: 1.5, sm: 2, md: 4 },
            bgcolor: isDarkMode ? 'rgba(30, 41, 59, 0.8)' : 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(10px)',
            mx: { xs: 0.5, sm: 0 },
          }}
        >
          {children}
        </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default UserPageLayout;
